import { Table } from "@tanstack/react-table"
import PaginationWrapper from "../wrapper"

type Props = {
  instance: Table<any>
  totalCount?: number
  siblingCount?: number
  viewType?: "grid" | "table"
  removeMobilePagination?: boolean
}

const TanstackPagination = ({
  instance,
  totalCount,
  viewType,
  siblingCount,
  removeMobilePagination = false
}: Props) => {
  const { pageIndex, pageSize } = instance.getState().pagination

  const onClickPrev = instance.previousPage
  const onClickNext = instance.nextPage
  const disabledPrev = !instance.getCanPreviousPage()
  const disabledNext = !instance.getCanNextPage()

  return (
    <PaginationWrapper
      siblingCount={siblingCount}
      pageIndex={pageIndex}
      pageSize={pageSize}
      totalCount={totalCount}
      className={`${
        viewType === "grid" ? "" : "bg-white"
      } border-t border-gray-200`}
      removeMobilePagination={removeMobilePagination}
      onClickPrev={onClickPrev}
      onClickNext={onClickNext}
      setPageIndex={instance.setPageIndex}
      disabledPrev={disabledPrev}
      disabledNext={disabledNext}
      rowCount={instance.getPrePaginationRowModel().rows.length}
    />
  )
}

export default TanstackPagination
